<template>
  <div class="root">
    <img class="icon" src="../assets/logo.png" alt />
    <form class="box">
      <div class="header">Sign in to Regents HR Portal</div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-label">Enter your email address</div>
          <input class="control" type="input" v-model="username" required />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-label">Enter your password</div>
          <input class="control" type="password" v-model="password" required />
        </div>
      </div>
      <div class="form-group">
        <button
          class="button-square dark-blue"
          style="flex: 1 1 auto"
          @click="login($event)"
        >
          <div v-if="signingIn" class="loader"></div>
          <div v-if="!signingIn">SIGN IN</div>
        </button>
      </div>
    </form>
    <Notif v-if="notif" :data.sync="notif"></Notif>
  </div>
</template>

<script>
import { http } from '../digilib_web/core/digitify';
import Notif from '../digilib_web/vue/notif';

export default {
  props: {
    isLoggedIn: Boolean
  },
  components: {
    Notif
  },
  methods: {
    login: function(ev) {
      if (this.username && this.password) {
        ev.preventDefault();
        if (this.signingIn) {
          return;
        }
        this.signingIn = true;
        let uname = this.username;
        if (uname.includes('tester')) {
          uname = this.username;
        } else {
          uname = uname.includes('@regentsschoolbali.com')
            ? this.username
            : `${this.username}@regentsschoolbali.com`;
        }

        let payload = { username: uname, password: this.password };
        http.post('login', payload).then(json => {
          this.signingIn = false;
          if (json.success) {
            this.$emit('update:isLoggedIn', true);
            localStorage.setItem('regent_profile_id', +json.data.id);
          } else {
            this.notif = { text: json.msg, color: 'red' };
          }
        });
      }
    }
  },
  data() {
    return {
      signingIn: false,
      username: '',
      password: '',
      notif: null
    };
  }
};
</script>

<style scoped>
.root {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.header {
  display: -webkit-flex;
  display: flex;
  padding: 10px;
  background-color: #f7f8f7;
}
.icon {
  width: 165px;
  height: 72px;
  margin-bottom: 40px;
}
.box {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.8);
  border-radius: 4px 4px 4px 4px;
  font-size: 0.9em;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  width: 300px;
  background-color: rgba(255, 255, 255, 0.7);
}
.form-group {
  display: -webkit-flex;
  display: flex;
  padding: 10px;
}
.input-group {
  display: -webkit-flex;
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
}
.input-label {
  color: rgb(209, 209, 209);
}
.control {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  line-height: 1.25;
  color: #464a4c;
  height: 32px;
  border-radius: 0.2rem;
  background-color: #fff;
}
@media all and (max-width: 640px) {
  .box {
    width: 92vw;
  }
}
</style>
